import { render, staticRenderFns } from "./BoAccountSetting.vue?vue&type=template&id=080f92c6"
import script from "./BoAccountSetting.vue?vue&type=script&lang=js"
export * from "./BoAccountSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports